module.exports = __webpack_public_path__ + "static/img/jc-3.a518f6a6.webp";